import {useDelete, useGet, usePut} from "@hooks/http.ts";
import {useCallback} from "react";
import {useOnce} from "@hooks/once.ts";
import {ApiSpeedDialList, ApiSpeedDialSlot} from "@api/speed-dial.tsx";

type SpeedDialListAction = (abortController?: AbortController) => void;
export const useSpeedDialList = (): readonly [
        Array<ApiSpeedDialSlot> | undefined,
    boolean,
        Error | undefined,
    SpeedDialListAction
] => {
    const [response, loading, error, get] = useGet<ApiSpeedDialList>();

    const fetchSpeedDials = useCallback((abortController?: AbortController) => {
        console.trace("fetching speed dials");
        get(`/v1/speed-dials`, abortController);
    }, [get]);

    useOnce(() => {
        fetchSpeedDials()
    }, [fetchSpeedDials]);

    return [response?.slots, loading, error, fetchSpeedDials] as const;
}

type SpeedDialSetAction = (slot: number, pair: number, abortController?: AbortController) => void;
export const useSpeedDialSet = (): readonly [ApiSpeedDialSlot | undefined, boolean, Error | undefined, SpeedDialSetAction] => {
    const [response, loading, error, put] = usePut<ApiSpeedDialSlot>();

    const setSpeedDial = useCallback((slot: number, pair: number, abortController?: AbortController) => {
        console.trace("fetching speed dials");
        put(`/v1/speed-dials/${slot}`, {pair}, abortController);
    }, [put]);

    return [response, loading, error, setSpeedDial] as const;
}


type SpeedDialDeleteAction = (slot: number, abortController?: AbortController) => void;
export const useSpeedDialDelete = (): readonly [
    boolean,
        Error | undefined,
    SpeedDialDeleteAction
] => {
    const [loading, error, del] = useDelete();

    const deleteSpeedDial = useCallback((slot: number, abortController?: AbortController) => {
        console.trace("fetching speed dials");
        del(`/v1/speed-dials/${slot}`, abortController);
    }, [del]);


    return [loading, error, deleteSpeedDial] as const;
}